<template>
  <div class="wh100" :class="{'padding-style':isCard}">
    <div class="layout-topfilter" :class="{'card':isCard}">
      <div class="title-container" v-if="title" :style="titleStyle" :class="titleClass">
        <div class="title-left">
          <div class="icon">
            <slot name="icon">
              <div class="default-icon" v-if="defaultIcon"></div>
            </slot>
          </div>
          <div class="title">{{title}}</div>
        </div>
        <div class="title-right">
          <slot name="title-right"></slot>
        </div>
      </div>
      <div class="content-container" :class="{'ext-filter-content':extraFilter}">
        <div class="filter-container" :style="filterStyle" :class="filterClass" ref="mainFilter">
          <div class="divquery">
            <slot name="filter"></slot>
          </div>
          <el-tooltip content="更多筛选条件" placement="top">
            <i
              class="el-icon-arrow-down ext-filter-btn"
              v-if="extraFilter"
              :class="{'ext-filter-btn-up':this.extFilterVisible}"
              @click="extFilterClick"
            ></i>
          </el-tooltip>
        </div>
        <div class="show-container" :style="contentStyle" :class="contentClass">
          <slot name="content"></slot>
        </div>
        <transition name="el-zoom-in-top" v-if="extraFilter">
          <div ref="extFilter" class="ext-filter" v-if="extraFilter" v-show="extFilterVisible">
            <slot name="extFilter"></slot>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "layouttopfilter",
  props: {
    extraFilter: {
      type: Boolean,
      default: false,
    },
    //标题，不传值时默认不显示标题
    title: {
      type: String,
      default: "",
    },
    //是否使用card风格
    isCard: {
      type: Boolean,
      default: false,
    },
    //是否使用默认标题图标
    defaultIcon: {
      type: Boolean,
      default: true,
    },
    //内容区域的style，可自定义背景色，字体，边距等，下同
    contentStyle: {
      type: String,
      default: "",
    },
    contentClass:{
       type: String,
      default: "",
    },
    //条件区域style
    filterStyle: {
      type: String,
      default: "",
    },
    filterClass: {
      type: String,
      default: "",
    },
    //标题栏区域style
    titleStyle: {
      type: String,
      default: "",
    },
    titleClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      extFilterVisible: false,
    };
  },
  methods: {
    extFilterClick() {
      debugger;

      let mainFilterHeight =
        Number(
          window
            .getComputedStyle(this.$refs.mainFilter)
            .getPropertyValue("height")
            .replace("px", "")
        ) + 15;
      this.$refs.extFilter.style.top = mainFilterHeight + "px";
      this.extFilterVisible = !this.extFilterVisible;
    },
  },
};
</script>
<style lang="less" scoped>
.layout-topfilter {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #303133;
}
.padding-style {
  padding: 20px;
  box-sizing: border-box;
}
.card {
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.title-container {
  flex-grow: 0;
  height: 47px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  justify-content: space-between;
}
.title-left,
.title-right {
  height: 100%;
  display: flex;
  align-items: center;
}
.icon {
  margin-right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}
.default-icon {
  height: 50%;
  width: 4px;
  background: @basecolor;
  border-radius: 25%;
}
.title {
  font-size: 16px;
}
.content-container {
  display: flex;
  flex: 1;
  height: 0;
  flex-direction: column;
  box-sizing: border-box;
}
.filter-container {
  display: flex;
  align-items: center;
  padding: 15px 15px 0 15px;
  z-index: 5;
}
.show-container {
  padding: 15px;
  flex: 1;
  height: 0;
}
.ext-filter-content {
  position: relative;
}
.ext-filter {
  position: absolute;
  width: 100%;
  z-index: 4;
  box-sizing: border-box;
  box-shadow: 0 5px 4px -4px rgba(0, 0, 0, 0.1);
  padding: 15px 15px 15px 15px;
  border-bottom: 1px solid #eee;
  border-radius: 0 0 4px 4px;
  left: 0;
  background: #fff;
}
.ext-filter-btn {
  margin-left: 15px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.3s;
  outline: medium;
  margin-bottom:8px;
}
.ext-filter-btn-up {
  transform: rotate(180deg);
}
.divquery {
  width: 100%;
}
</style>